/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AddOrUpdateGoodsVo } from './AddOrUpdateGoodsVo';
import {
    AddOrUpdateGoodsVoFromJSON,
    AddOrUpdateGoodsVoFromJSONTyped,
    AddOrUpdateGoodsVoToJSON,
    AddOrUpdateGoodsVoToJSONTyped,
} from './AddOrUpdateGoodsVo';
import type { ComposedGoodsVo } from './ComposedGoodsVo';
import {
    ComposedGoodsVoFromJSON,
    ComposedGoodsVoFromJSONTyped,
    ComposedGoodsVoToJSON,
    ComposedGoodsVoToJSONTyped,
} from './ComposedGoodsVo';

/**
 * 
 * @export
 * @interface GoodsComposeDetailVo
 */
export interface GoodsComposeDetailVo {
    /**
     * 订单编号
     * @type {string}
     * @memberof GoodsComposeDetailVo
     */
    orderCode?: string;
    /**
     * 仓库名称
     * @type {string}
     * @memberof GoodsComposeDetailVo
     */
    warehouseName?: string;
    /**
     * 订单状态名称
     * @type {string}
     * @memberof GoodsComposeDetailVo
     */
    orderStatusName?: string;
    /**
     * 请求分组
     * @type {string}
     * @memberof GoodsComposeDetailVo
     */
    requestGroup?: string;
    /**
     * 未合包商品列表
     * @type {Array<AddOrUpdateGoodsVo>}
     * @memberof GoodsComposeDetailVo
     */
    unComposedGoods?: Array<AddOrUpdateGoodsVo>;
    /**
     * 合包商品列表
     * @type {Array<ComposedGoodsVo>}
     * @memberof GoodsComposeDetailVo
     */
    composedGoods?: Array<ComposedGoodsVo>;
}

/**
 * Check if a given object implements the GoodsComposeDetailVo interface.
 */
export function instanceOfGoodsComposeDetailVo(value: object): value is GoodsComposeDetailVo {
    return true;
}

export function GoodsComposeDetailVoFromJSON(json: any): GoodsComposeDetailVo {
    return GoodsComposeDetailVoFromJSONTyped(json, false);
}

export function GoodsComposeDetailVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoodsComposeDetailVo {
    if (json == null) {
        return json;
    }
    return {
        
        'orderCode': json['orderCode'] == null ? undefined : json['orderCode'],
        'warehouseName': json['warehouseName'] == null ? undefined : json['warehouseName'],
        'orderStatusName': json['orderStatusName'] == null ? undefined : json['orderStatusName'],
        'requestGroup': json['requestGroup'] == null ? undefined : json['requestGroup'],
        'unComposedGoods': json['unComposedGoods'] == null ? undefined : ((json['unComposedGoods'] as Array<any>).map(AddOrUpdateGoodsVoFromJSON)),
        'composedGoods': json['composedGoods'] == null ? undefined : ((json['composedGoods'] as Array<any>).map(ComposedGoodsVoFromJSON)),
    };
}

export function GoodsComposeDetailVoToJSON(json: any): GoodsComposeDetailVo {
    return GoodsComposeDetailVoToJSONTyped(json, false);
}

export function GoodsComposeDetailVoToJSONTyped(value?: GoodsComposeDetailVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderCode': value['orderCode'],
        'warehouseName': value['warehouseName'],
        'orderStatusName': value['orderStatusName'],
        'requestGroup': value['requestGroup'],
        'unComposedGoods': value['unComposedGoods'] == null ? undefined : ((value['unComposedGoods'] as Array<any>).map(AddOrUpdateGoodsVoToJSON)),
        'composedGoods': value['composedGoods'] == null ? undefined : ((value['composedGoods'] as Array<any>).map(ComposedGoodsVoToJSON)),
    };
}

